import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {ApiVisa} from '../../shared/api-visa.model';

@Injectable({
  providedIn: 'root'
})
export class ShopeeGetTrackingNumberService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/logistic/ship-order';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/logistic/get-tracking-Number';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + 'shopee/logistic/get-tracking-Number';
    this.httpClient = http;
  }

  getTracking(branchGuid: string, package_number: string, order_sn: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid + '&' + 'package_number=' + package_number + '&' + 'order_sn=' + order_sn;
    return this.httpClient.post(url, null, this.getHttpHeader(apiVisa));
  }

  getTrackingPromise(branchGuid: string, package_number: string, order_sn: string, type: string, dtoObject: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?' + 'branch_guid=' + branchGuid + '&' + 'package_number=' + package_number + '&' + 'order_sn=' + order_sn + '&' + 'type=' + type;
    return this.httpClient.post(url, dtoObject, this.getHttpHeader(apiVisa)).toPromise();
  }
}
